// const initialState = {
//     loading: false,
//     error: null,
//     data: null,
//   };

// export const QrJobReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case "FETCH_ASSIGN_JOB_QR_REQUEST":
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };
//     case "FETCH_ASSIGN_JOB_QR_SUCCESS":
//       return {
//         ...state,
//         loading: false,
//         data: action.payload, // Success data
//       };
//     case "FETCH_ASSIGN_JOB_QR_FAILURE":
//       return {
//         ...state,
//         loading: false,
//         error: action.error,
//       };
//     default:
//       return state;
//   }
// };

const initialState = {
    loading: false,
    error: null,
    data: null,
  };

export const QrJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ASSIGN_JOB_QR_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_ASSIGN_JOB_QR_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload, // Success data
      };
    case "FETCH_ASSIGN_JOB_QR_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};